import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showLoading, showAlert } from "../Actions/GeneralActions";
import { headers } from "../../utills";
import {
  getChatList,
  getChatMessages,
  getChatRoom,
  getGuestList,
  getMessages,
  getVendorList,
  getVendorMessages,
  resetChat,
} from "../Actions/ChatActions";

export const ChatMiddleware = {
  createChatRoom: ({ name, event_id, image, topics, members }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (event_id) {
            formdata.append("event_id", event_id);
          }
          formdata.append("name", name);
          formdata.append("image", image);
          if (topics.length > 0) {
            for (const [index, item] of topics.entries()) {
              formdata.append(`topics[${index}]`, item);
            }
          }
          if (members.length > 0) {
            for (const [index, item] of members.entries()) {
              formdata.append(`members[${index}]`, item.id);
            }
          }
          const data = await Axios.post(
            Apis.createChatRoom,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getChatRoom(data?.data?.data));
            resolve(data?.data?.data);
            dispatch(
              showAlert({
                title: "createChatRoom",
                message: data.data?.message,
                type: "Success",
                status: 200,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createChatRoom",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  editChatRoom: (event_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", event_data?.id);
          formdata.append("name", event_data?.name);
          if (event_data?.image) formdata.append("image", event_data?.image);
          if (event_data?.topics.length > 0) {
            for (const [index, item] of event_data?.topics.entries()) {
              formdata.append(`topics[${index}]`, item?.name);
            }
          }
          // else {
          //     formdata.append(`topics[]`, [])
          // }
          if (event_data?.members?.length > 0) {
            for (const [index, item] of event_data?.members.entries()) {
              formdata.append(`members[${index}]`, item?.id);
            }
          }

          const data = await Axios.post(
            Apis.updateChatRoom,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "updateChatRoom",
                message: data.data?.message,
                type: "Success",
                status: 200,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "updateChatRoom",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getChatRoom: ({ name }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (name) formdata.append("name", name);
          const data = await Axios.post(
            Apis.chatRoomLists,
            name ? formdata : {},
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getChatRoom(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getChatRoom",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getChatRoomMessages: ({ id, topic_id, next_page_url }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (next_page_url == undefined) {
            dispatch(resetChat());
          }
          let formdata = new FormData();
          formdata.append("id", id);
          formdata.append("topic_id", topic_id);
          const data = await Axios.post(
            Apis.chatRoomMessages(next_page_url),
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getChatMessages(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          console.log(error);
          reject(error);
          dispatch(
            showAlert({
              title: "getChatRoomMessages",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  sendGroupMessage: ({ room_id, topic_id, type, message }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("chat_room_id", room_id);
          formdata.append("topic_id", topic_id);
          formdata.append("type", type);
          formdata.append("message", message);
          const data = await Axios.post(
            Apis.sendGroupMessage,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "sendGroupMessage",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createChatRoomTopic: ({ id, name }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("chat_room_id", id);
          formdata.append("name", name);
          const data = await Axios.post(
            Apis.createChatRoomTopic,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createChatRoomTopic",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getChatRoomMembers: ({ id, name }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (name) formdata.append("name", name);

          formdata.append("chat_room_id", id);
          const data = await Axios.post(
            Apis.getChatRoomMembers,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getChatRoomMembers",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  //Single Chat
  getChatListData: ({ search }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (search) formdata.append("name", search);
          const data = await Axios.post(
            Apis.chatList,
            search ? formdata : {},
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getChatList(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getChatListData",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getChatMessagesData: ({ id, next_page_url }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (next_page_url == undefined) {
            dispatch(resetChat());
          }
          let formdata = new FormData();
          formdata.append("chat_list_id", id);
          const data = await Axios.post(
            Apis.chatDetail(next_page_url),
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            if (data?.data?.data != null)
              dispatch(getMessages(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getChatMessagesData",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  sendMessage: ({ id, type, message }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("chat_list_id", id);
          formdata.append("type", type);
          formdata.append("message", message);
          const data = await Axios.post(
            Apis.sendMessage,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "sendMessage",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getVendorChatListData: ({ search }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (search) formdata.append("name", search);
          const data = await Axios.post(
            Apis.vendorsChatList,
            search ? formdata : {},
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getVendorMessages(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getVendorChatListData",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createChatList: ({ id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("receiver_id", id);
          const data = await Axios.post(
            Apis.createChatList,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createChatList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  GetGuestList: ({ search }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (search) formdata.append("name", search);
          const data = await Axios.post(
            Apis.getGuestList,
            search ? formdata : {},
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getGuestList(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getGuestList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  GetClientsList: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getVendorClients,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getGuestList(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getGuestList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  GetVendorList: ({ search }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (search) formdata.append("name", search);
          const data = await Axios.post(
            Apis.getVendorList,
            search ? formdata : {},
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getVendorList(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getVendorList",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
